import React from 'react';
import MembersApi from '../../../../services/portal-api/MembersApi';
import moment from "moment/moment";
import HelpTips from "../../../../components/HelpTip/statusHint";
import CheckboxInput from '../../../../components/Form/components/CheckboxInput';
import swal from 'sweetalert';

export default class CreateMemberJob extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            retrying: false,
            marking: false,
            jobId: this.props.jobDetails.id,
            data: {},
        }
        this._runJob = this._runJob.bind(this);
    }

    componentDidMount(){
        const data = this.state.data;
        //data["futura_customer_id"] = this.props.jobDetails.futura_customer_id;
        data["rewards_card_number"] = this.props.jobDetails.rewards_card_number;
        data["email"] =  this.props.jobDetails.email;
        data["created_at"] =  this.convertUTCToLocalTime(this.props.jobDetails.created_at);
        data["failed_at"] =  this.props.jobDetails.failed_at;
        data["failed_on"] = this.props.jobDetails.failed_on;
        data["givex_activation_completed_at"] = this.props.jobDetails.givex_activation_completed_at ? this.convertUTCToLocalTime(this.props.jobDetails.givex_activation_completed_at) : this.props.jobDetails.givex_activation_completed_at;
        data["exported_member_futura_at"] = this.props.jobDetails.exported_member_futura_at ? this.convertUTCToLocalTime(this.props.jobDetails.exported_member_futura_at) : this.props.jobDetails.exported_member_futura_at;
        data["exported_welcome_cert_magento_at"] = this.props.jobDetails.exported_welcome_cert_magento_at ? this.convertUTCToLocalTime(this.props.jobDetails.exported_welcome_cert_magento_at) : this.props.jobDetails.exported_welcome_cert_magento_at;
        data["manually"] = this.props.jobDetails.manually;

        this.setState({
            data : data
        });
    }
    
    convertUTCToLocalTime = (dateString) => {
        let date = new Date(dateString);
        const milliseconds = Date.UTC(
          date.getFullYear(),
          date.getMonth(),
          date.getDate(),
          date.getHours(),
          date.getMinutes(),
          date.getSeconds(),
        );
        const localTime = new Date(milliseconds);
        let cd = localTime.getFullYear()+"-"+(localTime.getMonth()+1)+"-"+localTime.getDate()+" "+localTime.getHours()+":"+localTime.getMinutes()+":"+localTime.getSeconds();
        return moment(cd).format('DD/MM/YYYY h:mm A');
    };

    _checkud = (event) => {
        const mark = event.target.checked;
        const {jobId} = this.state;
        this.props.markem(jobId,mark);
    }

    _runJob(event){
        this.setState({
            retrying: true   
        });  

        this.props.Job(this.state.jobId,'new_member',() => {
            MembersApi.getJobs((response)=>{
              if(response.success){

                  const data = this.state.data;
                  //data["futura_customer_id"] = response.json.result.futura_customer_id;
                  data["rewards_card_number"] = response.json.result.rewards_card_number;
                  data["email"] =  response.json.result.email;
                  data["created_at"] =  this.convertUTCToLocalTime(response.json.result.created_at);
                  data["failed_at"] =  response.json.result.failed_at;
                  data["failed_on"] = response.json.result.failed_on;
                  data["givex_activation_completed_at"] = response.json.result.givex_activation_completed_at ? this.convertUTCToLocalTime(response.json.result.givex_activation_completed_at) : response.json.result.givex_activation_completed_at;
                  data["exported_member_futura_at"] = response.json.result.exported_member_futura_at ? this.convertUTCToLocalTime(response.json.result.exported_member_futura_at) : response.json.result.exported_member_futura_at;
                  data["exported_welcome_cert_magento_at"] = response.json.result.exported_welcome_cert_magento_at ? this.convertUTCToLocalTime(response.json.result.exported_welcome_cert_magento_at) : response.json.result.exported_welcome_cert_magento_at;
                  data["manually"] = response.json.result.manually;

                  this.setState({
                  data : data,  
                  retrying: false   
                  },()=>{console.log(this.state)});

              } else {
                if(response.status === 401){
                    this.props.crtSessionLogger(response);
                } else {
                    // alert("Sorry, Unable to fetch job status");
                    swal("Sorry, Unable to fetch job status", {
                        icon: "warning",
                        buttons: false,
                        timer: 3000
                    });
                }
              }     
            },'new_member',this.state.jobId);
           // this.setState({
           //   retrying: false   
           // },()=>{console.log(this.state)});  
        });
    }

    _markJob = (event) => {
        this.setState({
            marking: true   
        },()=>{
            MembersApi.markTheJobs((response)=>{
                if(response.success){
                    
                    MembersApi.getJobs((response)=>{
                        if(response.success){
            
                            const {data} = this.state;
                            data["failed_at"] =  response.json.result.failed_at;
                            data["failed_on"] = response.json.result.failed_on;
                            data["givex_activation_completed_at"] = response.json.result.givex_activation_completed_at ? this.convertUTCToLocalTime(response.json.result.givex_activation_completed_at) : response.json.result.givex_activation_completed_at;
                            data["exported_member_futura_at"] = response.json.result.exported_member_futura_at ? this.convertUTCToLocalTime(response.json.result.exported_member_futura_at) : response.json.result.exported_member_futura_at;
                            data["exported_welcome_cert_magento_at"] = response.json.result.exported_welcome_cert_magento_at ? this.convertUTCToLocalTime(response.json.result.exported_welcome_cert_magento_at) : response.json.result.exported_welcome_cert_magento_at;
                            data["manually"] = response.json.result.manually;

                            this.setState({
                            data : data,  
                            marking: false   
                            },()=>{console.log("mark",this.state)});
            
                        } else {
                            // alert("Sorry, Unable to fetch job status");
                            swal("Sorry, Unable to fetch job status", {
                                icon: "warning",
                                buttons: false,
                                timer: 3000
                            });
                        }     
                    },'new_member',this.state.jobId);
                    
                } else {
                    if(response.status === 401){
                        this.props.crtSessionLogger(response);
                    } else {
                        // alert("Sorry, Unable to fetch job status");
                        swal("Sorry, Unable to fetch job status", {
                            icon: "warning",
                            buttons: false,
                            timer: 3000
                        });
                    }
                }  
            },this.state.jobId,'new_member');
        });
    }

    render(){
        let status = this.state.retrying ? "Retrying" : "Retry";
        let mark = this.state.marking ? "Completing" : "Complete";
        let details = "admintools/jobs/"+this.state.jobId+"/new_member";
        return (<tr>
            <td style={{paddingTop:17,paddingBottom:17,width:17}}>
            {this.state.data.failed_at && <div className='col'>
                    <input className="checkbox" type="checkbox" onChange={this._checkud} checked={this.props.checked} style={{height:20, width:20}}/>
                </div>}
            </td>
            <td style={{paddingTop:17,paddingBottom:17}}><strong><a href={details} target="_blank" style={{color:"#21a573"}}>{this.state.data.rewards_card_number}</a></strong></td>
            <td style={{paddingTop:17,paddingBottom:17,width:'19%',wordBreak:'break-all'}}>{this.state.data.email}</td>
            <td style={{paddingTop:17,paddingBottom:17}}>{this.state.data.created_at}</td>

            <td style={{paddingTop:17,paddingBottom:17}}><b>{this.state.data.failed_at ? "Failed": (this.state.data.manually == 1 ? "Success - Manually" : ( this.state.data.givex_activation_completed_at && this.state.data.exported_welcome_cert_magento_at && this.state.data.exported_member_futura_at && !this.state.data.failed_at ? "Success": (!this.state.data.failed_at && (this.state.data.givex_activation_completed_at || this.state.data.exported_welcome_cert_magento_at || this.state.data.exported_member_futura_at) ? "In-Progress":"Pending")))}</b></td>
            
            <td style={{paddingTop:17,paddingBottom:17}}>{this.state.data.failed_on ? this.state.data.failed_on : " ---- "}</td>
            <td style={{paddingTop:17,paddingBottom:17}}>{this.state.data.failed_at && <button className="btn btn--xsmall btn--open" onClick={this._runJob}> {status} {this.state.retrying && <img className="icon" src="/img/Gear-job.gif" style={{width:20,height:20,top:"34%",marginTop:-5,right:8}}></img>}</button>}
            {this.state.data.failed_at == null && <span> ---- </span>}
            </td>
            <td style={{paddingTop:17,paddingBottom:17}}>{this.state.data.failed_at && <button className="btn btn--xsmall btn--open" onClick={this._markJob}> {mark} {this.state.marking && <img className="icon" src="/img/Gear-job.gif" style={{width:20,height:20,top:"34%",marginTop:-5,right:8}}></img>}</button>}
            {this.state.data.failed_at == null && <span> ---- </span>}
            </td>
            <td style={{paddingTop:17,paddingBottom:17,width:"15%"}}>

                <HelpTips zind={this.props.zindex} stage="G" strobe={this.state.data.givex_activation_completed_at ? "#21a573": (this.state.data.failed_on == "Givex" && this.state.data.failed_at ? "red" : "grey")}>
                   <span>Givex<br></br>{this.state.data.givex_activation_completed_at ? "Completed at: " + this.state.data.givex_activation_completed_at : (this.state.data.failed_on == "Givex" && this.state.data.failed_at ? "Failed at: " + this.state.data.failed_at : "Pending")}</span>    
                </HelpTips>
                <HelpTips zind={this.props.zindex} stage="F" strobe={this.state.data.exported_member_futura_at ? "#21a573": ((this.state.data.failed_on == "Futura" && this.state.data.failed_at) ? "red" : "grey")}>   
                   <span>Futura<br></br>{this.state.data.exported_member_futura_at ? "Completed at: " + this.state.data.exported_member_futura_at : (this.state.data.failed_on == "Futura" && this.state.data.failed_at ? "Failed at: " + this.state.data.failed_at : "Pending")}</span> 
                </HelpTips>
                <HelpTips zind={this.props.zindex} stage="D" strobe={this.state.data.exported_welcome_cert_magento_at ? "#21a573": (this.state.data.failed_on == "DotDigital" && this.state.data.failed_at ? "red" : "grey")}>   
                   <span>Dotdigital<br></br>{this.state.data.exported_welcome_cert_magento_at ? "Completed at: " + this.state.data.exported_welcome_cert_magento_at : (this.state.data.failed_on == "DotDigital" && this.state.data.failed_at ? "Failed at: " + this.state.data.failed_at : "Pending")}</span> 
                </HelpTips>
            </td>
        </tr>);
    }
}